<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Purchase Goods</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/goods-receipt">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row dense id="po">
          <v-col cols="12" xs="12" sm="12" md="3">
            <v-autocomplete autocomplete="off" dense outlined v-model="record.CardCode" :items="suppliers"
              label="Supplier" item-text="Name" item-value="id" :search-input.sync="searchSuppliers">
              <template v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn class="ma-2" color="accent" dark small elevation="0" @click="openCreate()">
                    <v-icon left>mdi-plus</v-icon>Create A Supplier
                  </v-btn>
                </v-row>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="3">
            <span v-if="dateReadonly == 'Y' && role != 3" style="font-weight: bold; font-size: 16px">Date: {{ date
            }}</span>
            <DatePicker v-else @date="setDate" :myDate="date" :title="`Date`" ref="dateRef"></DatePicker>
          </v-col>

          <!-- add products -->
          <v-col cols="12">
            <v-btn text color="primary" @click="openModal">
              <v-icon>mdi-plus</v-icon>Add Product To Purchase
            </v-btn>

            <v-data-table light dense :items-per-page="pageItems" :headers="headers" :items="orderItems"
              item-key="LineNum" hide-default-footer disable-sort :mobile-breakpoint="0" :calculate-widths="true">
              <template v-slot:item.num="{ item, index }">
                <span>{{ index + 1 }}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <span style="margin-right: 15px !important">
                  {{
                    item.Quantity
                  }}
                </span>
              </template>

              <template v-slot:item.Price="{ item }">
                <span style="margin-right: 15px !important">
                  {{
                    item.Price.toLocaleString()
                  }}
                </span>
              </template>

              <template v-slot:item.DisplayTotal="{ item }">
                <span>{{ item.DisplayTotal.toLocaleString() }}</span>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
          <!-- end -->
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn color="primary" text @click.native="paymentDialog = true">
              <v-icon left>mdi-plus</v-icon>Add Payment
            </v-btn>
          </v-col>

          <v-col cols="12" xs="12" style="margin-top: -30px">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Account</th>
                    <th class="text-left">Amount</th>
                    <th class="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in payments" :key="item.account">
                    <td>{{ item.account }}</td>
                    <td>{{ item.SumApplied.toLocaleString() }}</td>
                    <td>
                      <v-btn @click="deleteAccount(item)" color="red" icon>
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col cols="12" xs="12">
            <v-row dense class="style-16 mt-2">
              <v-col cols="12">
                Bill:
                <span style="float: right">{{ totalAmount | currency }}</span>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row dense class="style-16 mt-2">
              <v-col cols="12">
                Paid:
                <span style="float: right">{{ totalPayments | currency }}</span>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row dense class="style-16 mt-2">
              <v-col cols="12">
                Balance:
                <span style="float: right">{{ balance | currency }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn small v-if="docCreate == true" color="primary" @click="sendData" :loading="$store.state.btnLoader">
              <v-icon left>mdi-content-save</v-icon>Receive / Add Stock
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <!-- purchase dialog -->
          <v-dialog v-model="purchaseDialog">
            <v-card>
              <v-toolbar dense color="secondary" flat>
                <v-toolbar-title>Product Selection</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="purchaseDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row>
                    <v-col cols="12" xs="12" md="4">
                      <v-autocomplete autocomplete="off" dense outlined single-line v-model="purchaseItem.id"
                        :items="products" label="Select Product" item-text="Name" item-value="id" @change="setOrderItem"
                        :search-input.sync="searchProducts">
                        <template v-slot:no-data>
                          <v-row align="center" justify="center">
                            <v-btn :loading="searchingProduct" class="ma-2" color="accent" dark small elevation="0"
                              @click="productModal()">
                              <v-icon left>mdi-plus</v-icon>Create A Product
                            </v-btn>
                          </v-row>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6" xs="6" md="6">
                      <v-text-field autocomplete="off" type="number" v-model="purchaseItem.Quantity"
                        @input="qtyChanged(purchaseItem)" label="Qty" outlined dense></v-text-field>
                    </v-col>

                    <v-col cols="6" xs="6" md="6">
                      <v-text-field autocomplete="off" type="text" name="goodsReceiptUom" filled outlined readonly dense
                        value="Unit(s)" v-if="purchaseItem.ManualStatus == 'Y'"></v-text-field>
                      <v-autocomplete autocomplete="off" v-else dense outlined single-line
                        v-model="purchaseItem.UomEntry" :items="purchaseItem.ugp1" label="UOM" item-text="UomName"
                        item-value="UomId" @change="uomChanged(purchaseItem)"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" xs="12" md="12">
                      <v-text-field autocomplete="off" type="number" v-model="purchaseItem.Price"
                        @input="qtyChanged(purchaseItem)" label="Price" outlined dense></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12">Total: {{ purchaseItem.LineTotal | currency }}</v-col>

                    <v-col cols="12">
                      <v-btn color="primary" small @click="addProduct" :loading="loader">
                        <v-icon left>mdi-plus</v-icon>Add To List
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of products modal-->
        </v-row>
        <!-- snackbar -->

        <!-- Payment dialog -->
        <v-dialog v-model="paymentDialog">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title>Record Payment</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="paymentDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12">
                    <v-autocomplete autocomplete="off" hide-details dense outlined v-model="paymentItem.o_a_c_t_s_id"
                      :items="accounts" label="Account" item-text="Name" item-value="id"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12">
                    <v-text-field autocomplete="off" type="number" v-model="paymentItem.SumApplied" label="Amount Paid"
                      outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12">
                    <v-text-field autocomplete="off" type="text" v-model="paymentItem.PaymentRemarks" label="Ref / No"
                      outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="primary" @click="addPayment" :loading="loader">
                      <v-icon left>mdi-plus</v-icon>Add Payment
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of payment modal-->
      </v-card-text>
    </v-card>

    <!-- Supplier quick add dialog -->
    <v-dialog v-model="supplierDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Create A Supplier</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="supplierDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <supplier-editor :initial="supplierItem" @data="saveSupplier"></supplier-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->


    <!-- product quick add dialog -->
    <v-dialog v-model="productDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create A Product</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="productDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <product-editor :docCreate="true" :initial="productItem" @data="saveProduct"></product-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>


<script>
import ProductEditor from "@/components/subscriber/products/creation/_components/editor.vue";
import SupplierEditor from "@/components/subscriber/suppliers/_components/quick-editor.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  name: "NewPurchaseOrder",
  components: {
    ProductEditor,
    SupplierEditor
  },
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    supplierItem: {},
    supplierDialog: false,
    purchaseDialog: false,
    paymentDialog: false,
    paymentItem: {},
    productDialog: false,
    productItem: {},
    payments: [],
    purchaseItem: {},
    taxGroups: [],
    selectedProduct: null,
    searchProducts: null,
    SumApplied: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentMode: null,
    searchSuppliers: null,
    accounts: [],
    orderItems: [],
    suppliers: [],
    products: [],
    stores: [],
    date: new Date().toISOString().substr(0, 10),
    todayDate: new Date().toISOString().substr(0, 10),
    dateReadonly: "",
    headers: [
      { text: "No.", value: "num" },
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Uom", value: "uomEntryName" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" }
    ]
  }),
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    totalPayments() {
      let total = 0;
      if (typeof this.payments != "undefined" && this.payments.length > 0) {
        return this.payments
          .map(item => {
            const amount = parseFloat(item.SumApplied);
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    balance() {
      let bill = 0;
      let paid = 0;
      bill = this.totalAmount;
      paid = this.totalPayments;
      const balance = bill - paid;
      return balance;
    }
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true
    },
    searchSuppliers(val) {
      if (val && val !== this.select && this.querySuppliers(val)) {
        this.querySuppliers(val);
      }
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    }
  },
  methods: {
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }
    },
    openCreate() {
      this.supplierDialog = true;
    },
    saveSupplier(data) {
      var storeId = parseInt(this.activeStore);
      data.store_id = storeId;
      const url = "/suppliers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show("Supplier Added Successully", "green");
            self.supplierDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveProduct(data) {
      data.store_id = parseInt(this.activeStore);
      const url = "/products";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.productDialog = false;
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show("Product added Successfully", "green");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    productModal() {
      this.productDialog = true;
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null && res.ResponseData.length > 0) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySuppliers(searchText) {
      const self = this;
      const url = "/suppliers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    openModal() {
      this.purchaseItem = {};
      this.purchaseItem.id = null;
      this.purchaseDialog = true;
    },
    uomChanged(item) {
      this.purchaseItem.Price = null;
      let ugp1 = [];
      ugp1 = item.ugp1;
      if (ugp1) {
        let ugp1Record = ugp1.find(record => {
          return record.UomEntry === item.UomEntry;
        });
        this.purchaseItem.uomEntryName = ugp1Record.UomName;
        this.purchaseItem.Price = ugp1Record.BuyingPrice;

        // update LineTotal
        var total = this.purchaseItem.Quantity * this.purchaseItem.Price;
        console.log(total);
        this.purchaseItem.LineTotal = total;
      }
    },
    qtyChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.purchaseItem.LineTotal = LineTotal;
      this.purchaseItem.DisplayTotal = DisplayTotal;
    },
    addProduct() {
      if (
        this.purchaseItem.Quantity == null ||
        this.purchaseItem.Price == null ||
        this.purchaseItem.id == null
      ) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
      } else {
        const self = this;
        const initArray = [];
        initArray.push(self.purchaseItem);
        self.orderItems = [...self.orderItems, ...initArray];
        this.purchaseItem = {};
        this.purchaseDialog = false;
      }
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    deleteAccount(item) {
      const selectedRow = this.payments.find(record => {
        return record.o_a_c_t_s_id === item.o_a_c_t_s_id;
      });
      const pos = this.payments.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.payments.splice(pos, 1);
    },
    addPayment() {
      const accoutId = this.paymentItem.o_a_c_t_s_id;
      if (accoutId == undefined) {
        this.$refs.snackbar.show("Please select payment mode!", "red");
      } else {
        if (this.paymentItem.SumApplied == undefined) {
          this.$refs.snackbar.show("Please enter amount paid!", "red");
        } else {
          const paymentAccount = this.payments.find(record => {
            return record.o_a_c_t_s_id === accoutId;
          });

          if (paymentAccount == undefined) {
            const item = this.paymentItem;
            const account = this.accounts.find(record => {
              return record.id === accoutId;
            });
            // check if payment mode exist

            const data = {
              o_a_c_t_s_id: account.id,
              account: account.Name,
              SumApplied: item.SumApplied,
              PaymentRemarks: item.PaymentRemarks
            };
            this.payments.push(data);
            this.paymentItem = {};
            this.paymentDialog = false;
          } else {
            this.$refs.snackbar.show("That payment mode exist!", "red");
          }
          // end of check
        }
      }
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/products/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            // current item definition
            let currentItem = {};
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.PUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            if (product.HasUom === 0) {
              // check if manual yes and assign
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = buyingPrice;
              currentItem.currentPrice = buyingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;

              this.select = null;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.PUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.Price = ugp1Record.BuyingPrice;
              currentItem.currentPrice = ugp1Record.BuyingPrice;
              const total = 0;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = 0;
              this.select = "";
              self.products = [];
              // end of push
            }

            this.purchaseItem = { ...this.purchaseItem, ...currentItem };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    generateUniqueId() {
      var subscriberId = localStorage.getItem("subscriber_id");
      var date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      var dateString = `${year}-${month}-${day}`;
      var uniqueId = `${uuidv4()}-${dateString}-${subscriberId}`;
      return uniqueId;
    },
    sendData() {
      if (this.record.CardCode == null || this.record.CardCode == undefined) {
        this.$refs.snackbar.show("Please select supplier !", "red");
        return;
      }

      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.orderItems.length <= 0) {
        this.$refs.snackbar.show("You must have at least one product", "red");
        return;
      }

      // create unique id
      var uniqueId = this.generateUniqueId();
      // end of unique id

      let saleDate = this.date;
      this.record = { ...this.record, DocDate: saleDate };
      const data = this.record;
      data.uniqueId = uniqueId;
      data.ObjType = 12;
      data.DocTotal = this.totalAmount;
      data.DocNum = this.DocNum;
      data.ref2 = this.ref2;
      var storeId = parseInt(this.activeStore);
      data.storeId = storeId;
      data.CreatedBy = parseInt(this.userSign);
      data.terms = this.terms;

      // append order rows
      var orderData = this.orderItems;

      var rows = [];
      for (const row of orderData) {
        var details = {
          productId: row.o_i_t_m_s_id,
          UomEntry: row.UomEntry,
          Quantity: parseFloat(row.Quantity),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          name: row.Name,
          storeId: storeId
        };

        rows.push(details);
      }
      // end

      data.rows = rows;

      let paymentsArray = [];
      const accountsData = this.payments;
      if (accountsData != undefined && accountsData.length > 0) {
        for (const account of accountsData) {
          if (account.SumApplied) {
            let details = {
              accountId: parseInt(account.o_a_c_t_s_id),
              Amount: parseFloat(account.SumApplied),
              RefNo: account.PaymentRemarks
            };

            paymentsArray.push(details);
          }
        }
      }

      data.payments = paymentsArray;
      // save data
      const url = "/purchases/create-document";
      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getDocNum();
            const NewDate = this.record.DocDate;
            self.record = {};
            self.record.DocDate = NewDate;
            if (self.clearDate == "Y") {
              this.$refs.dateRef.clearDate();
            }
            self.orderItems = [];
            self.SumApplied = 0;
            self.DiscOnTotal = 0;
            self.ref2 = null;
            self.UserSign = null;
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show("Created successful", "green");
            self.$router.push("/goods-receipt");
            this.loader = false;
          } else {
            this.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dateReadonly = res.ResponseData.dateReadonly;
            if (res.ResponseData.DefaultStockStore) {
              if (self.docCreate) {
                self.record.DocDate = new Date().toISOString().substr(0, 10);
              }
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/12`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (self.docCreate == true) {
              self.record = {
                ...self.record,
                DocNum: res.ResponseData
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([
      this.getAccounts(),
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum()
    ]);
  }
};
</script>

<style scoped>
/* .v-text-field__details {
    display: none !important;
  } */
</style>